<template>
  <div>
    <record
      :settings="settings"
      :name="name"
      v-if="!saved"
      :onUpload="saveCode"
    />
    <success v-if="saved" :code="saved" />
  </div>
</template>
<script>
export default {
  components: {
    record() {
      return import("@/components/recorder/record");
    },
    success() {
      return import("@/components/recorder/success");
    }
  },
  props: {
    settings: Object,
    name: [String, Number]
  },
  data() {
    return {
      saved: false
    };
  },
  methods: {
    saveCode(code) {
      this.saved = code;
    }
  },
  mounted() {},
  computed: {}
};
</script>
<style lang="sass" scoped></style>
